<div class="spinner-container">
  <div class="spinner"></div>
  <div class="loading-text">{{ loadingText }}</div>
</div>
